import styled from 'styled-components'

const Section = styled.section`
  position: absolute;
  padding: 16px 8px;
  border: 1px solid #ccc;
  background-color: #fff;
`

export default Section
